import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  transition: all 0.5s;
  opacity: ${(props) => (!props.isSelected ? 0.5 : 1)};
  background: transparent;
  @media (max-width: 1400px) {
    width: 80px;
    font-size: 14px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  margin-top: 2px;
  margin-left: 5px;
  overflow: visible;
  pointer-events: ${(props) => (props.isSelected ? true : "none")};
`;

export const Icon = styled.svg`
  fill: none;
  stroke: ${(props) => (props.isSelected ? colors.white1 : colors.gray4)};
  stroke-width: 3px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  box-shadow: ${colors.blue1} 0px 22px 70px 4px;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  width: 15px;
  height: 15px;
  background: ${(props) =>
    props.checked && props.isSelected
      ? `${colors.red2}`
      : props.isSelected
      ? `${colors.redCheckboxBackground}`
      : "transparent"};
  border-radius: 3px;
  transition: all 0.4s;
  box-shadow: 0px 22px 70px 4px;
  border: ${(props) =>
    props.checked && props.isSelected
      ? "none"
      : props.isSelected
      ? `2px solid ${colors.red2}`
      : `2px solid ${colors.gray3}`};
  box-sizing: border-box;
  ${HiddenCheckbox}:focus + & {
    box-shadow: ${(props) => (props.checked ? `${colors.red2} 0px 3px 8px` : "rgba(0, 0, 0, 0.24) 0px 3px 8px")};
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;
